module.exports = __webpack_public_path__ + "media/images/salespartner/problem02-4afadd549703fd60eba8bbfffb8db54d.svg";